import HoverIconButton from "components/HoverIconButton";
import Pill from "components/Pill";
import { STATUS, UI_THEME } from "utils/constants/ui";
import classnames from "classnames";

const InheritenceDisplay = ({
  title,
  onRemove,
  children,
  hideAction,
  error
}) => {
  return (
    <div className="flex flex-column justify-between items-start pa2 br2 hairline-1 ba w-100">
      <div className="flex flex-column justify-between items-start w-100">
        <div className="flex flex-row justify-between items-center w-100">
          <div
            className={classnames("f5 fw6 db", {
              "color-error": Boolean(error)
            })}
          >
            {title}
          </div>
          <div className="dib">
            <div className="flex flex-row items-center justify-center">
              <Pill
                theme={UI_THEME}
                status={STATUS.WARNING}
                copy="Inherited"
                customClasses={{
                  container: "flex w-100 items-end justify-end mr1",
                  copy: "f7 pa1 br2 fw6 flex-shrink-0 items-center"
                }}
              />
              {!hideAction && (
                <HoverIconButton icon="close" onClick={onRemove} />
              )}
            </div>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default InheritenceDisplay;
